<template>
  <div class="pa-4">
    <h1>carousel</h1>
    <CarouselCard class="fill-height" />
  </div>
</template>

<script>
import CarouselCard from './CarouselCard.vue';

export default {
  components: {
    CarouselCard,
  },
}
</script>

<style scoped>

</style>